import CloseIcon from '@mui/icons-material/Close'
import { Button, Popover, Box, IconButton, Typography } from '@mui/material'
import I18n from 'i18n-js'
import moment from 'moment'
import { useState } from 'react'
import { makeStyles } from 'tss-react/mui'

import { CalendarEventType } from './Calendar'
import CalendarEvent from './CalendarEvent'

const useStyles = makeStyles()((theme) => ({
  showMoreButton: {
    fontSize: theme.typography.caption.fontSize,
    height: '20px',
    marginTop: theme.spacing(1),
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.text.secondary,
  },
  container: {
    textAlign: 'center',
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
}))

interface ShowMoreComponentProps {
  date?: Date
  count: number
  events?: CalendarEventType[]
  onSelect?: (event: CalendarEventType) => void
}

const CalendarShowMore: React.FC<
  React.PropsWithChildren<ShowMoreComponentProps>
> = ({
  events = [],
  date,
  count,
  onSelect = (event: CalendarEventType) => {},
}) => {
  const { classes } = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)

  return (
    <div className={classes.container}>
      <Popover
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {events.length && date && (
          <div style={{ padding: '8px', maxWidth: '300px' }}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="flex-start"
              minWidth="200px"
              position={'relative'}
            >
              <Box display="flex" flexDirection="column" alignItems="center">
                <Typography variant="caption" color="textSecondary">
                  {moment(date).format('MMM')}
                </Typography>
                <Typography variant="h6">{moment(date).date()}</Typography>
              </Box>
              <IconButton
                size="small"
                onClick={handlePopoverClose}
                className={classes.closeButton}
              >
                <CloseIcon />
              </IconButton>
            </Box>
            {events.map((event) => (
              <Box
                key={event?.item?.id}
                marginBottom={1}
                onClick={() => {
                  onSelect(event)
                  handlePopoverClose()
                }}
              >
                <CalendarEvent event={event} />
              </Box>
            ))}
          </div>
        )}
      </Popover>
      <Button
        size="small"
        className={classes.showMoreButton}
        onClick={anchorEl ? handlePopoverClose : handlePopoverOpen}
      >
        {I18n.t('calendar.showMore', { count })}
      </Button>
    </div>
  )
}
export default CalendarShowMore
